<template>
  <article
    class="project-tile"
    :class="{ 'only-content': logo == '', 'open': isActiveTile }"
    @click="toggleTile"
  >
    <div class="project-tile__cover">
      <img
        :src="logo"
        alt=""
      >
    </div>
    <div class="project-tile__content">
      <h3
        v-if="title"
        class="project-tile__header"
      >
        .{{ title }}
      </h3>
      <h3
        v-else
        class="project-tile__header"
      />
      <div class="project-tile__scope">
        <p v-html="scopes"/>
      </div>
    </div>
  </article>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    logo: {
      type: String,
      default: ''
    },
    scopes: {
      type: String,
      default: () => []
    },
    isActiveTile: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleTile () {
      this.$emit('click')
    }
  }

}
</script>

<style lang="scss" scoped>
  .project-tile {
    @include grid-column((xs: 12, md: 4));
    position: relative;
    padding-top: 33.333%;
    @include media-down(md) {
      padding-top: 50%;
    }

    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    &:nth-of-type(even) {
      background: #000;
      @include font-white;
    }
    &.only-content & {
      &__content {
        opacity: 1;
        transition: opacity 0.3s ease-in;
      }
      &__cover {
        opacity: 0;
        transition: opacity 0.35s ease-out;
      }
    }
    @include media-down(md) {
      &.open & {
        &__content {
          opacity: 1;
          transition: opacity 0.3s ease-in;
        }
        &__cover {
          opacity: 0;
          transition: opacity 0.35s ease-out;
        }
      }
    }
    @include media-up(md) {
      &:hover & {
        &__content {
          opacity: 1;
          transition: opacity 0.3s ease-in;
        }
        &__cover {
          opacity: 0;
          transition: opacity 0.35s ease-out;
        }
      }
    }

    &__cover,
    &__content {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
    &__cover {
      @include center-content;
      transition: opacity 0.3s ease-in;
      img {
        max-width: 50%;
        max-height: 50%;
        @include media-up(lg) {
          max-width: 70%;
          max-height: 70%;
        }
      }
    }
    &__content {
      opacity: 0;
      transition: opacity 0.35s ease-out;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      padding: 20px 20px 16px;
      @include media-up(lg) {
        justify-content: space-between;
        padding: 24px 24px 16px;
      }
    }
    &__header {
      @include font-style-medium-project;
      margin: 0 0 0.3em 0;
    }
    &__scope {
      @include font-style-small;
      p {
        margin: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ProjectTile.vue